import {ReactElement} from 'react';

export * from './RecalcSettings';
export * from './AppendRecord';
export * from './NewDayStarted';
export * from './RedistributeSaved';
export * from './SpendSaved';
export * from './DeleteRecord';

export * from './RefreshCore';
export * from './RefreshStore';

export interface AdapteeProps {
  [key: string]: () => void;
}

export interface AdapterProps {
  children: (props: AdapteeProps) => ReactElement;
}
